import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import TriggerFieldToolTip from './TriggerFieldToolTip';
import { useTriggerForm } from '../useTriggerForm.js';
import {
    FORM_FIELD_PATHS,
    showsEntityDropdown,
} from '../triggerFormConstants.js';

import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const TriggerEntityDropdown = ({
    darkMode,
    companies,
    partners,
    wholesalers,
    errors,
    touched,
    isCompanyAdmin,
    requiredScope,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useTriggerForm();

    if (!showsEntityDropdown(formData?.triggerType, requiredScope)) return null;

    const getEntityData = () => {
        switch (formData.triggerType) {
            case 'Company':
                return {
                    data: companies || [],
                    field: FORM_FIELD_PATHS.COMPANY_ID,
                    currentId: formData?.companyID,
                    label: 'Company',
                    placeholder: 'Select Company',
                };
            case 'Partner':
                return {
                    data: partners || [],
                    field: FORM_FIELD_PATHS.PARTNER_ID,
                    currentId: formData?.partnerID,
                    label: 'Partner',
                    placeholder: 'Select Partner',
                };
            case 'Wholesaler':
                return {
                    data: wholesalers || [],
                    field: FORM_FIELD_PATHS.WHOLESALER_ID,
                    currentId: formData?.wholesalerID,
                    label: 'Wholesaler',
                    placeholder: 'Select Wholesaler',
                };
            default:
                return null;
        }
    };

    const entityConfig = getEntityData();
    if (!entityConfig) return null;

    const entityLabel = entityConfig.label.toLowerCase();
    const entityID = entityConfig.field;

    const handleSelectChange = (item) => {
        const selectedId = item?.id;
        updateFormData(entityConfig.field, selectedId);
    };

    const hasError = !!errors?.[entityID] && touched?.[entityID];

    return (
        <FormControl
            sx={{ margin: '0 !important', position: 'relative' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    {entityConfig.label}{' '}
                    {!isCompanyAdmin && (
                        <span style={{ color: '#e53e3e' }}>*</span>
                    )}
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={DropDown}
                        id={entityConfig.field}
                        name={entityConfig.field}
                        data={entityConfig.data}
                        shownValue="name"
                        currentId={entityConfig.currentId}
                        selectedId="id"
                        placeholder={entityConfig.placeholder}
                        handleSelectChange={handleSelectChange}
                        width="100%"
                        isLoading={false}
                        darkMode={darkMode}
                        validate={(value) => {
                            if (!value && !isCompanyAdmin) {
                                return `Please select a ${entityLabel}`;
                            }
                        }}
                    />
                </Box>
                <TriggerFieldToolTip
                    isVisible={isHovered}
                    label={`Select the specific ${entityLabel} this trigger applies to`}
                    ariaLabel="trigger-entity-tip"
                />
            </Stack>
        </FormControl>
    );
};

export default TriggerEntityDropdown;
